import {directions} from '../constants';
import {findPatternCells,setCaretPosition,getCaretPosition} from './common';
import {patternsFoundSingleton} from './patterns-found-singleton';

let foundPatternsAddedCount = 0;

export const getCellRefComponent= ({cellRefsMap,cellRefs})=> (row,col)=>{
    const cellRefIndex = cellRefsMap[`${row}_${col}`];
    if(cellRefIndex){
        return cellRefs.current[cellRefIndex];
    }
};

export const focusCellComponent = ({getCellRef})=>(row,col,pos)=>{
    const cellRef = getCellRef(row,col);

    if(cellRef && cellRef.current){

        //console.log('focus cell',cellRef.current,row,col,pos);

        setCaretPosition(cellRef.current,pos);
        //cellRef.current.focus();
    }else{
        //console.log('cannot focus',row,col,cellRef,cellRefsMap,cellRefs.current.length,cellRefs.current.filter(c=>!!c).length);
        /* for(let i=0;i<cellRefs.current.length;i++){
            console.log('cellref',i,cellRefs.current[i]);
        } */
    }
};

export const addtoFoundPatternsComponent = ({foundPatternCells,setFoundPatternCells,foundPatterns,setFoundPatterns})=>(patterns)=>{
    
    if(patterns.length === 0) return;

    //console.log('add to found patterns',patterns);

    //let copyFoundPatterns = [...patternsFoundSingleton.patterns];
    let copyFoundPatternCells = { ...foundPatternCells };

    for (let pattern of patterns) {
      //console.log('add to found patterns',pattern,foundPatterns);
      const patternsCells = findPatternCells(pattern);

      copyFoundPatternCells = { ...copyFoundPatternCells, ...patternsCells };

      //copyFoundPatterns = [...copyFoundPatterns, pattern];

      patternsFoundSingleton.add(pattern);
     
    }

    //console.log('copy found patterns',copyFoundPatterns);
    //console.log('copy found pattern cells',Object.keys(copyFoundPatternCells).length,copyFoundPatternCells);
    
    setFoundPatternCells(copyFoundPatternCells);

    foundPatternsAddedCount = foundPatternsAddedCount + patterns.length;

    console.log('found pattern added count',patterns.length,foundPatternsAddedCount,patternsFoundSingleton.patterns.length);

    setFoundPatterns([...patternsFoundSingleton.patterns]);
    //setFoundPatterns(copyFoundPatterns);

};

export const patternClickComponent = ({setPatternCells,setSelectedPattern,setActiveTab})=> (pattern)=>{
    //console.log('pattern clicked',pattern);
    const patternCells = findPatternCells(pattern);

    //console.log('pattern cells',patternCells);

    setPatternCells(patternCells);
    setSelectedPattern(pattern);
    setActiveTab(pattern.direction);
    /* if(pattern.direction === 0 && horizontalClues.current){
        horizontalClues.current.scrollTop = 200;
    }else if(pattern.direction === 1 && verticalClues.current){
        verticalClues.current.scrollTop = 150;
    } */
};



let keydownVal;
export const onKeyDownComponent = ({findFirstEnabledCell,setCell,getCellRef,focusCell,selectedPattern})=>(e,code,key,row,col)=>{
    //console.log(`on key down ${code}, ${key}`);
    
    keydownVal = getCellRef(row,col).current.value;

    //console.log('keydown val',keydownVal);

    const moveBack = ()=>{
        let nextRow = row;
            let nextCol = col;

            if(selectedPattern.direction === 0){ //horizontal
                nextCol = col -1;
            }else{ //vertical
                nextRow = row - 1;
            }

            const firstEnabledCell = findFirstEnabledCell(selectedPattern,nextRow,nextCol,false);

            if(firstEnabledCell){
                const {row,col} = firstEnabledCell;
                focusCell(row,col,1);
            }
            
    };

    if(key === 'Backspace'){

        const cell = getCellRef(row,col).current;
         
        //console.log('On Back Space',cell.value);

         if(cell.value === ''){
            
            moveBack();
                                 
            
         }else{
            const pos = getCaretPosition(cell);
            if(pos===0){
                moveBack();
            }
         }
    }else{
        if(!['ArrowDown','ArrowUp','ArrowLeft','ArrowRight'].includes(key)){
            setCell(row,col,'');
        }
        
    }
    
};

export const onKeyUpComponent = ({findFirstEnabledCell,findContainingPatternsForCellClicked,onPatternClick,focusCell})=> (e,code,key,row,col)=>{
    //console.log('onCellKey',code,row,col);
    let nextRow = row;
    let nextCol = col;
    let direction;

    //console.log('on key up',e.target.value);

    e.target.value = e.target.value.substring(0,1);

    let isForward = false;

    switch(code){
        case 'ArrowDown':
            nextRow = row + 1;
            direction = directions.VERTICAL;
            isForward = true;                        
            break;
        case 'ArrowUp':                        
            nextRow = row -1;
            direction = directions.VERTICAL;
            break;
        case 'ArrowLeft':
            nextCol = col -1;
            direction = directions.HORIZONTAL;
            break;
        case 'ArrowRight':                        
            nextCol = col + 1;
            direction = directions.HORIZONTAL;
            isForward = true;
            break;                    
        default:
            
    }

    let pattern;

    if(direction){
        //console.log('direction',direction);
        const patterns = findContainingPatternsForCellClicked(row,col);
        //console.log('patterns',patterns);
        if(direction === directions.HORIZONTAL && patterns.horizontal){
            pattern = patterns.horizontal;
           
        }else if(direction === directions.VERTICAL && patterns.vertical){
            pattern = patterns.vertical;
           
        }

        if(pattern) onPatternClick(pattern);
    }

    if(nextRow!==row || nextCol!==col){
       
       
        const firstEnabledCell = findFirstEnabledCell(pattern,nextRow,nextCol,isForward);

        if(firstEnabledCell){
            const {row,col} = firstEnabledCell;
            focusCell(row,col,0);
        }
        
    }                    

};

export const onKeyPressComponent = ({setCell,focusCell,selectedPattern})=> (e,row,col)=>{
    setCell(row,col,'');
    //console.log('keypress',e);
    
    let nextRow = row;
    let nextCol = col;

    if(selectedPattern.direction === 0){ //horizontal
          nextCol = col + 1;
    }else{ //vertical
          nextRow = row + 1;
    }

    focusCell(nextRow,nextCol);    
    
};

export const onInputComponent = ({findFirstEnabledCell,getCellRef,focusCell,selectedPattern})=> (e,row,col)=>{
    //setCell(row,col,'');
    //console.log('keypress',e);

    //console.log('input',e);

    
    
    let currentVal = getCellRef(row,col).current.value;

    //console.log('input',row,col,keydownVal,currentVal);

    let nextRow = row;
    let nextCol = col;

    if((keydownVal===currentVal && keydownVal === '') || (keydownVal!=='' && currentVal==='')){ //backspace
   
        return;
    }
   
    
    let onLastCell = false;

    if(selectedPattern.direction === 0){ //horizontal
          const lastCol = selectedPattern.col + selectedPattern.length -1;
          
          onLastCell = lastCol === col;

          if(!onLastCell) nextCol = col + 1;
          
           
    }else{ //vertical

         const lastRow = selectedPattern.row + selectedPattern.length -1;

         onLastCell = lastRow === row;

         if(!onLastCell) nextRow = row + 1;
    }

    
    if(!onLastCell) {

        const firstEnabledCell = findFirstEnabledCell(selectedPattern,nextRow,nextCol,true);

        //console.log('onInput firstEnabledCell',nextRow,nextCol,firstEnabledCell);

        if(firstEnabledCell){
            const {row,col} = firstEnabledCell;
            focusCell(row,col,0);
        }

    } 
            
    
};


export const findFirstEnabledCellComponent = ({findPatternCells, getCellRef})=> (pattern,startRow,startCol,isForward)=>{
        
    let patternCells = Object.keys(findPatternCells(pattern)).map(c=>{
         const [row,col] = c.split('_').map(part=>+part);
         
         return {row,col,cellRef:getCellRef(row,col)};             

    }).filter(c=>{
        if(pattern.direction === 0){
            return isForward ? c.col >= startCol : c.col <=startCol; 
        }else{
            return isForward ? c.row >= startRow : c.row <=startRow;
        }
    });

    patternCells = isForward ? patternCells : patternCells.reverse();

    //console.log('pattern cells',patternCells);

    const firstEnabledCell = patternCells.find(c=>c.cellRef.current && !c.cellRef.current.disabled);

    return firstEnabledCell;
    
};



export const onListPatternClickComponent = ({findFirstEnabledCell,onPatternClick,focusCell})=>(p)=>{
    onPatternClick(p);
        
    const firstEnabledCell = findFirstEnabledCell(p,0,0,true);

    if(firstEnabledCell){
    
        const {row,col} = firstEnabledCell;
        
        focusCell(row,col,0);

    }
    
};

export const onCellClickComponent = ({findContainingPatternsForCellClicked,onPatternClick,selectedPattern})=> (row,col)=>{
    //console.log('Cell clicked',row,col);
    const match = findContainingPatternsForCellClicked(row,col);

    if(match.horizontal && match.horizontal !== selectedPattern ){
        onPatternClick(match.horizontal);
    }else if(match.vertical && match.vertical !== selectedPattern){
        onPatternClick(match.vertical);
    }
};